import React from "react";
import { slugToTitle } from "../../../services/utils";
import "./whatsAppButton.scss";

interface WhatsAppButtonProps {
  projectName: string;
  whatsApp: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  projectName,
  whatsApp,
}) => {
  return (
    <a
      className="wa-button"
      href={`https://wa.me/${whatsApp}?text=Hola,%20me%20gustar%C3%ADa%20saber%20m%C3%A1s%20acerca%20de%20${slugToTitle(
        projectName
      )}`}
      target="_blank"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.58 74.58">
        <g id="Capa_2" data-name="Capa 2">
          <g id="Capa_1-2" data-name="Capa 1">
            <circle className="wa-circle" cx="37.29" cy="37.29" r="36.79" />
            <path
              className="wa-path"
              d="M53.41,35.81a13,13,0,0,0-.76-4.16,16.39,16.39,0,0,0-9.08-9.71c-1-.45-2.14-1.51-3.27-1.68-.58-.09-1.16-.86-1.74-.86H38.3l-.38,0a2.34,2.34,0,0,0-.38,0H36c-.07,0-.15.74-.22.75a16.15,16.15,0,0,0-2,.54,17,17,0,0,0-4.53,1.93,16.84,16.84,0,0,0-4.21,3.55,15.32,15.32,0,0,0-2.55,4,14.52,14.52,0,0,0-1.26,4.31,25.85,25.85,0,0,0-.07,3.63,12,12,0,0,0,.46,3,13.44,13.44,0,0,0,.94,2.55,1.47,1.47,0,0,1,.12,1c-.4,1.88-.78,3.76-1.17,5.64a7.2,7.2,0,0,0-.34,1.77c0,.52,0,.26.47.26H22c.47,0,.95.34,1.42.23,2.07-.5,4.15-.77,6.22-1.27a1.34,1.34,0,0,1,.88.2A16.15,16.15,0,0,0,45.24,51a16.47,16.47,0,0,0,4.21-3.4,15.84,15.84,0,0,0,2.59-4,14.17,14.17,0,0,0,1.29-4.35A27.12,27.12,0,0,0,53.41,35.81ZM48.3,43a12.51,12.51,0,0,1-9.39,6.4c-.55.08-1.1,0-1.53.11a12.3,12.3,0,0,1-5.91-1.44,2.34,2.34,0,0,0-1.88-.22c-1.21.35-2.46.59-3.69.9-.27.06-.31,0-.26-.26.32-1.48.62-3,.93-4.43a.82.82,0,0,0-.09-.63,13.68,13.68,0,0,1-1.56-4.19,12.58,12.58,0,0,1,.86-7.39,12.6,12.6,0,0,1,18.32-5.5,12.57,12.57,0,0,1,4.42,4.9A12.56,12.56,0,0,1,48.3,43Z"
            />
            <path
              className="wa-path"
              d="M41.75,44.72a8.77,8.77,0,0,1-4.44-1.17,18.61,18.61,0,0,1-7-6.68,7.75,7.75,0,0,1-1.05-3A4.25,4.25,0,0,1,30.62,30c.19-.18.38-.36.58-.53a1.14,1.14,0,0,1,1.84.33c.47,1,.9,2,1.33,3A1.13,1.13,0,0,1,34.2,34c-.19.25-.39.5-.58.76a1.15,1.15,0,0,0,0,1.51,16.21,16.21,0,0,0,3.22,3.24,9.4,9.4,0,0,0,1.85,1.22,1.15,1.15,0,0,0,1.42-.2c.23-.22.45-.45.67-.68a1.22,1.22,0,0,1,1.3-.35c1,.28,2,.56,3,.86a1.16,1.16,0,0,1,.64,1.86,11.58,11.58,0,0,1-.74,1A3.86,3.86,0,0,1,41.75,44.72Z"
            />
          </g>
        </g>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
